import {IDmLoaiThuTuyenSinh} from "../../model/respone/category/IDmLoaiThuTuyenSinh";
import {apiClient} from "../apiClient";

export const LOAI_THU_TUYEN_SINH_ENDPOINT = "loai-thu-tuyen-sinh";
export const loaiThuTuyenSinhApi = {
    SelectViewModelAll: () => apiClient.get(`${LOAI_THU_TUYEN_SINH_ENDPOINT}`),
    SelectByDot: (id_dot_tuyen: number) =>
        apiClient.get(
            `${LOAI_THU_TUYEN_SINH_ENDPOINT}/select-by-dot/${id_dot_tuyen}`
        ),
    Insert: (payload: IDmLoaiThuTuyenSinh) =>
        apiClient.post(`${LOAI_THU_TUYEN_SINH_ENDPOINT}`, payload),
    Update: (payload: IDmLoaiThuTuyenSinh) =>
        apiClient.put(`${LOAI_THU_TUYEN_SINH_ENDPOINT}`, payload),
    Delete: (id: number) =>
        apiClient.delete(`${LOAI_THU_TUYEN_SINH_ENDPOINT}/${id}`),
    DeleteMany: (ids: number[]) =>
        apiClient.post(`${LOAI_THU_TUYEN_SINH_ENDPOINT}/delete-many`, ids),
    SelectHeNganhsByDot: (id_dot_tuyen: number) =>
        apiClient.get(
            `${LOAI_THU_TUYEN_SINH_ENDPOINT}/select-he-nganhs/${id_dot_tuyen}`
        ),
    InsertMultiple: (payload: IDmLoaiThuTuyenSinh[]) =>
        apiClient.post(`${LOAI_THU_TUYEN_SINH_ENDPOINT}/insert-multiple`, payload),
};
